export type ChildBlockEntry = {
  block: BuilderBlock;
  path: string;
};

function toEntries(blocks: BuilderBlock[] | undefined, pathPrefix: string): ChildBlockEntry[] {
  if (!Array.isArray(blocks)) return [];

  return blocks
    .map((block, index) => ({ block, path: `${pathPrefix}.${index}` }))
    .filter((entry): entry is ChildBlockEntry => Boolean(entry.block));
}

/**
 * Merges blocks added via native canvas drag-and-drop (`builderBlock.children`) with blocks
 * added via a custom uiBlocks input, so both storage locations render in the editor and on the page.
 */
export function getMergedChildBlockEntries(
  builderBlock: BuilderBlock | null | undefined,
  customBlocks: BuilderBlock[] | undefined,
  customBlocksInputName = "childBlocks"
): ChildBlockEntry[] {
  const canvasBlocks = toEntries(builderBlock?.children, "this.children");
  const customBlockEntries = toEntries(customBlocks, customBlocksInputName);

  return [...canvasBlocks, ...customBlockEntries];
}
